<template>
  <div class="page-content">
    <div class="page-header">
      <h1>{{ pageTitle }}</h1>
      <div class="page-actions-wrapper">
        <slot name="actions"></slot>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    pageTitle: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  padding: 0 25px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  h1 {
    margin-top: 6px;
    margin-bottom: 6px;
  }
}

.page-actions-wrapper {
  display: flex;
  align-items: center;

  .el-select {
    margin-right: 10px;
  }
}
</style>
